module.exports = __webpack_public_path__ + "static/Portfolio03-fb5b9a7fadea75f6cb6c48cc9d8a4d0a.jpg";